import { useEffect, useState } from 'react';
import { compareAddresses } from '@/customercenter-ui/utils/addressUtil';
import { useAccount } from '@/frontastic';
import { ValidateAddressModal } from './validateAddressModal';
import * as CONSTANTS from '../../../../constants/constant';

interface ValidateAddressProps {
  formValues: any;
  pickListSelectedAddress: any;
  onSubmit: any;
  getValues?: any;
  editedAddress?: any;
  verifyAddressRef: any;
  pageName: string;
  setIsLoading?: any;
}

const ValidateAddress: React.FC<ValidateAddressProps> = ({
  formValues,
  pickListSelectedAddress,
  onSubmit,
  getValues,
  editedAddress,
  verifyAddressRef,
  pageName,
  setIsLoading = () => {},
}) => {
  const { validateAddress } = useAccount();
  const [validateAddressResponse, setValidateAddressResponse] = useState();
  const [formattingKey, setFormattingKey] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [addressValues, setAddressValues] = useState([]);

  const isValidationRequired = (addressDiffers: boolean, formValues: any, pageName: string) => {
    let isAddrValidationReqd = false;
    if (pageName === 'creditCard') {
      isAddrValidationReqd = addressDiffers && (formValues?.isNewAddress || formValues?.isAddressEdited);
    } else {
      isAddrValidationReqd = addressDiffers;
    }
    setAddressValues(formValues);
    return isAddrValidationReqd;
  };

  const verifyAddress = async (data: any) => {
    if (pageName === 'Checkout-LoggedIn-Saved-EditAddress') {
      const valuesToCopy = getValues();
      formValues = { ...formValues, ...valuesToCopy };
    } else {
      formValues = { ...formValues, ...data };
    }
    const addressDiffers = compareAddresses(formValues, pickListSelectedAddress);
    if (isValidationRequired(addressDiffers, formValues, pageName)) {
      const addressSoaResponse: any = await validateAddress(formValues);
      if (addressSoaResponse && addressSoaResponse?.data?.code === CONSTANTS.SUCCESS_CODE_OK) {
        if (addressSoaResponse?.data?.ValidateAddressResponse?.result === CONSTANTS.VERIFIED_MATCH) {
          mergeAddressFromExactMatch(
            addressSoaResponse?.data?.ValidateAddressResponse?.ValidatedAddress?.LocationInfo,
            formValues,
          );
        } else {
          setOpenModal(!openModal);
          setValidateAddressResponse(addressSoaResponse?.data?.ValidateAddressResponse);
        }
      } else {
        onSubmit(formValues);
      }
    } else {
      onSubmit(formValues);
    }
  };

  // Assign the verifyAddress function to the ref
  useEffect(() => {
    if (verifyAddressRef && verifyAddressRef.current) {
      verifyAddressRef.current = verifyAddress;
    }
  }, [verifyAddress]);

  const mergeAddressFromExactMatch = (locationInfo: any, formValues: any) => {
    formValues.streetName = locationInfo?.line1;
    formValues.additionalAddressInfo = locationInfo.line2;
    formValues.city = locationInfo.city;
    formValues.state = locationInfo.state;
    formValues.postalCode = locationInfo.zip;
    onSubmit(formValues);
  };

  const mergeDataWithFormData = async (data: any) => {
    let formData = formValues;

    if (pageName === 'checkout-LoggedIn-NewAddress' || pageName === 'Checkout-LoggedIn-Saved-EditAddress') {
      formData = { ...formData, ...addressValues };
    }
    const mergedData: any = { ...formData, ...data };
    if (data?.isEditSelectedFromModel) {
      const addressSoaResponse: any = await validateAddress(mergedData);

      if (addressSoaResponse && addressSoaResponse?.data?.code === CONSTANTS.SUCCESS_CODE_OK) {
        if (addressSoaResponse?.data?.ValidateAddressResponse?.result === CONSTANTS.VERIFIED_MATCH) {
          mergeAddressFromExactMatch(
            addressSoaResponse?.data?.ValidateAddressResponse?.ValidatedAddress?.LocationInfo,
            mergedData,
          );
        } else {
          setOpenModal(true);
          setValidateAddressResponse(addressSoaResponse?.data?.ValidateAddressResponse);
          setAddressValues(mergedData);
        }
      } else {
        onSubmit(mergedData);
      }
    } else if (data?.isSuggestedAddressFromModel) {
      const addressSoaResponse: any = await validateAddress(mergedData);
      if (addressSoaResponse && addressSoaResponse?.data?.code === CONSTANTS.SUCCESS_CODE_OK) {
        if (addressSoaResponse?.data?.ValidateAddressResponse?.result === CONSTANTS.VERIFIED_MATCH) {
          mergeAddressFromExactMatch(
            addressSoaResponse?.data?.ValidateAddressResponse?.ValidatedAddress?.LocationInfo,
            mergedData,
          );
        } else {
          setOpenModal(true);
          setValidateAddressResponse(addressSoaResponse?.data?.ValidateAddressResponse);
          setAddressValues(mergedData);
        }
      } else {
        onSubmit(mergedData);
      }
    } else {
      onSubmit(mergedData);
    }
  };

  return (
    <>
      {openModal ? (
        <ValidateAddressModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          editedAddress={editedAddress ?? getValues}
          values={addressValues}
          validateAddressResponse={validateAddressResponse}
          mergeDataWithFormData={mergeDataWithFormData}
          setFormattingKey={setFormattingKey}
          formattingKey={formattingKey}
          setIsLoading={setIsLoading}
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default ValidateAddress;
